import * as React from "react";
const SvgSubtitles = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ...props
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_4418_6729)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.5 22.0005H5.5C4.17441 21.9989 2.90356 21.4716 1.96622 20.5343C1.02888 19.5969 0.501588 18.3261 0.5 17.0005L0.5 7.00049C0.501588 5.67489 1.02888 4.40405 1.96622 3.46671C2.90356 2.52937 4.17441 2.00208 5.5 2.00049H19.5C20.8256 2.00208 22.0964 2.52937 23.0338 3.46671C23.9711 4.40405 24.4984 5.67489 24.5 7.00049V17.0005C24.4984 18.3261 23.9711 19.5969 23.0338 20.5343C22.0964 21.4716 20.8256 21.9989 19.5 22.0005ZM5.5 4.00049C4.70435 4.00049 3.94129 4.31656 3.37868 4.87917C2.81607 5.44178 2.5 6.20484 2.5 7.00049V17.0005C2.5 17.7961 2.81607 18.5592 3.37868 19.1218C3.94129 19.6844 4.70435 20.0005 5.5 20.0005H19.5C20.2956 20.0005 21.0587 19.6844 21.6213 19.1218C22.1839 18.5592 22.5 17.7961 22.5 17.0005V7.00049C22.5 6.20484 22.1839 5.44178 21.6213 4.87917C21.0587 4.31656 20.2956 4.00049 19.5 4.00049H5.5Z",
      fill: "#1B1C1D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.5 13.0005H11.5C11.2348 13.0005 10.9804 12.8951 10.7929 12.7076C10.6054 12.5201 10.5 12.2657 10.5 12.0005C10.5 11.7353 10.6054 11.4809 10.7929 11.2934C10.9804 11.1058 11.2348 11.0005 11.5 11.0005H19.5C19.7652 11.0005 20.0196 11.1058 20.2071 11.2934C20.3946 11.4809 20.5 11.7353 20.5 12.0005C20.5 12.2657 20.3946 12.5201 20.2071 12.7076C20.0196 12.8951 19.7652 13.0005 19.5 13.0005Z",
      fill: "#1B1C1D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.49999 13.0005H5.5C5.23478 13.0005 4.98043 12.8951 4.79289 12.7076C4.60536 12.5201 4.5 12.2657 4.5 12.0005C4.5 11.7353 4.60536 11.4809 4.79289 11.2934C4.98043 11.1058 5.23478 11.0005 5.5 11.0005H7.49999C7.76521 11.0005 8.01956 11.1058 8.2071 11.2934C8.39464 11.4809 8.49999 11.7353 8.49999 12.0005C8.49999 12.2657 8.39464 12.5201 8.2071 12.7076C8.01956 12.8951 7.76521 13.0005 7.49999 13.0005Z",
      fill: "#1B1C1D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.5 17.9995H5.5C5.23478 17.9995 4.98043 17.8942 4.79289 17.7066C4.60536 17.5191 4.5 17.2647 4.5 16.9995C4.5 16.7343 4.60536 16.4799 4.79289 16.2924C4.98043 16.1049 5.23478 15.9995 5.5 15.9995H13.5C13.7652 15.9995 14.0196 16.1049 14.2071 16.2924C14.3946 16.4799 14.5 16.7343 14.5 16.9995C14.5 17.2647 14.3946 17.5191 14.2071 17.7066C14.0196 17.8942 13.7652 17.9995 13.5 17.9995Z",
      fill: "#1B1C1D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.5 17.9995H17.5C17.2348 17.9995 16.9804 17.8942 16.7929 17.7066C16.6054 17.5191 16.5 17.2647 16.5 16.9995C16.5 16.7343 16.6054 16.4799 16.7929 16.2924C16.9804 16.1049 17.2348 15.9995 17.5 15.9995H19.5C19.7652 15.9995 20.0196 16.1049 20.2071 16.2924C20.3946 16.4799 20.5 16.7343 20.5 16.9995C20.5 17.2647 20.3946 17.5191 20.2071 17.7066C20.0196 17.8942 19.7652 17.9995 19.5 17.9995Z",
      fill: "#1B1C1D"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_4418_6729" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white", transform: "translate(0.5)" })))
);
export default SvgSubtitles;
